import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ContentCard from '../../../common/ContentCard';
import CodesTable from './CodesTable';
import {
    challengeCodesRequested,
    addChallengeCodeRequested,
    clearChallengeUpdateError,
} from '../actions';
import {
    getChallenge,
    getChallengeCodes,
    getChallengeCodesLoading,
    getChallengeCodeLoading,
    getChallengeCodeError,
} from '../selectors';
import LoaderGif from '../../../icons/LoaderGif.gif';
import { noop } from '../../../common/propTypes';
import './styles.scss';
import { getUser } from '../../auth/selectors';
import { TextField } from '@material-ui/core';

function ChallengeCodes({
    user,
    challenge,
    challengeCodes,
    fetchChallengeCodes,
    challengeCodesLoading,
    canCreateNewCodes,
    addChallengeCode,
    isAdding,
    error,
    canUpdateCodes,
    clearError,
}) {
    const [code, setCode] = useState('');
    useEffect(() => {
        if (challenge.id && !challengeCodesLoading) {
            fetchChallengeCodes();
        }
    }, [challenge]);

    useEffect(() => {
        if (!isAdding && !error) {
            setCode('');
        }
    }, [isAdding]);
    const onSubmit = () => {
        addChallengeCode({ code });
    };

    useEffect(() => {
        clearError();
    }, []);

    const mainContent = !challengeCodesLoading ? (
        challengeCodes.length ? (
            <>
                <div className="row">
                    <CodesTable
                        challengeCodes={challengeCodes}
                        canCreateNewCodes={canCreateNewCodes}
                        canUpdateCodes={canUpdateCodes}
                    />
                </div>
            </>
        ) : (
            'No Data Available'
        )
    ) : (
        <div className="card-loader">
            <img src={LoaderGif} alt=""></img>
        </div>
    );

    const challengeCreatedByUser =
        challenge &&
        user &&
        user.partnerId &&
        challenge.partnerId == user.partnerId;

    const header = (
        <>
            <h2 className="title">Challenge Codes</h2>
            {challengeCreatedByUser &&
            canCreateNewCodes &&
            challenge.isPublished ? (
                <div className="new-code-form">
                    <TextField
                        disabled={isAdding}
                        value={code}
                        error={error.length > 0}
                        helperText={error}
                        minLength="4"
                        maxLength="10"
                        type={'text'}
                        placeholder={'Enter new join code'}
                        onChange={(event) => setCode(event.target.value)}
                    />
                    <button
                        disabled={
                            isAdding || code.length > 10 || code.length < 4
                        }
                        onClick={onSubmit}
                    >
                        {isAdding ? (
                            <img
                                src={LoaderGif}
                                width={'25px'}
                                height={'25px'}
                            />
                        ) : (
                            'Add'
                        )}
                    </button>
                </div>
            ) : null}
        </>
    );

    return (
        <div className="content-box p-0">
            <ContentCard
                heading={header}
                subHeading={
                    'Totals for Participants and Litter Count from each of the codes associated with your challenge'
                }
                showDropDown={false}
                content={mainContent}
                className="challenge-codes"
            />
        </div>
    );
}

ChallengeCodes.propTypes = {
    challenge: PropTypes.object.isRequired,
    challengeCodes: PropTypes.array.isRequired,
    challengeCodesLoading: PropTypes.bool,
    fetchChallengeCodes: PropTypes.func,
    canCreateNewCodes: PropTypes.bool,
    user: PropTypes.object,
    isAdding: PropTypes.bool,
    addChallengeCode: PropTypes.func,
    error: PropTypes.string,
    canUpdateCodes: PropTypes.bool,
    clearError: PropTypes.func,
};

ChallengeCodes.defaultProps = {
    challengeCodes: [],
    fetchChallengeCodes: noop,
    canCreateNewCodes: false,
    user: {},
    isAdding: false,
    addChallengeCode: noop,
    error: '',
    canUpdateCodes: false,
    clearError: noop,
};

const mapStateToProps = (state) => {
    return {
        challenge: getChallenge(state),
        challengeCodes: getChallengeCodes(state),
        challengeCodesLoading: getChallengeCodesLoading(state),
        isAdding: getChallengeCodeLoading(state),
        user: getUser(state),
        error: getChallengeCodeError(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearError: () => dispatch(clearChallengeUpdateError()),
        fetchChallengeCodes: () => dispatch(challengeCodesRequested()),
        addChallengeCode: (data) => dispatch(addChallengeCodeRequested(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeCodes);
